import { useEffect } from "react";
import { hotjar } from "react-hotjar";
import { useLocation } from "react-router-dom";
import { getUserId } from "../utils/jwt";
hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, 6);

const HotjarHeatMap = () => {
  const location = useLocation();
  const userId = getUserId();

  useEffect(() => {
    if (hotjar.initialized()) {
      hotjar.stateChange(location.pathname);
      if (userId) {
        hotjar.identify("USER_ID", { userId: userId });
      }
    }
  }, [location, userId]);

  return null;
};

export default HotjarHeatMap;
